module.exports = __webpack_public_path__ + "static/media/web-ats-09.64e918fe.jpeg";